module.exports = "./img/0e4a16351cd58d726981c60bf789ddff.jpg";